"use client";

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from "react";
import { useCallback } from "react";
import { useSwipeDismiss } from "./useSwipeDismiss";
import { formatCountLabel } from "./wave-drops-scroll-controls.utils";
interface WaveDropsScrollControlsUnreadButtonProps {
  readonly unreadDividerSerialNo: number | null;
  readonly unreadCount?: number | undefined;
  readonly isPointingUp: boolean;
  readonly isCombined: boolean;
  readonly combinedWidthClassName: string;
  readonly roundedClassName: string;
  readonly onScrollToUnread: (serialNo: number) => void;
  readonly onDismissUnread: () => void;
}
export function WaveDropsScrollControlsUnreadButton(t0) {
  const $ = _c(42);
  const {
    unreadDividerSerialNo,
    unreadCount,
    isPointingUp,
    isCombined,
    combinedWidthClassName,
    roundedClassName,
    onScrollToUnread,
    onDismissUnread
  } = t0;
  let t1;
  if ($[0] !== onDismissUnread) {
    t1 = {
      onDismiss: onDismissUnread
    };
    $[0] = onDismissUnread;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    swipeOffset,
    swipeOpacity,
    consumeSuppressClick,
    handlers
  } = useSwipeDismiss(t1);
  let t2;
  if ($[2] !== consumeSuppressClick || $[3] !== onDismissUnread) {
    t2 = e => {
      if (consumeSuppressClick()) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      e.stopPropagation();
      onDismissUnread();
    };
    $[2] = consumeSuppressClick;
    $[3] = onDismissUnread;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDismiss = t2;
  let t3;
  if ($[5] !== consumeSuppressClick || $[6] !== onScrollToUnread || $[7] !== unreadDividerSerialNo) {
    t3 = e_0 => {
      if (consumeSuppressClick()) {
        e_0.stopPropagation();
        e_0.preventDefault();
        return;
      }
      if (unreadDividerSerialNo !== null) {
        onScrollToUnread(unreadDividerSerialNo);
      }
    };
    $[5] = consumeSuppressClick;
    $[6] = onScrollToUnread;
    $[7] = unreadDividerSerialNo;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleUnreadClick = t3;
  let t4;
  if ($[9] !== unreadCount) {
    t4 = formatCountLabel(unreadCount);
    $[9] = unreadCount;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const unreadCountLabel = t4;
  const hasUnreadCount = unreadCountLabel !== null;
  const t5 = isPointingUp ? "M5 10l7-7m0 0l7 7m-7-7v18" : "M19 14l-7 7m0 0l-7-7m7 7V3";
  let t6;
  if ($[11] !== t5) {
    t6 = <svg className="tw-size-4 tw-flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={t5} /></svg>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const unreadArrowIcon = t6;
  let t7;
  if ($[13] !== hasUnreadCount || $[14] !== isCombined || $[15] !== unreadArrowIcon || $[16] !== unreadCountLabel) {
    t7 = isCombined ? unreadArrowIcon : <>{unreadArrowIcon}{hasUnreadCount ? <span className="tw-text-sm tw-font-medium">{unreadCountLabel}</span> : null}</>;
    $[13] = hasUnreadCount;
    $[14] = isCombined;
    $[15] = unreadArrowIcon;
    $[16] = unreadCountLabel;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const unreadContent = t7;
  const t8 = `translateX(${swipeOffset}px)`;
  const t9 = swipeOffset === 0 ? "all 0.2s ease-out" : "none";
  let t10;
  if ($[18] !== swipeOpacity || $[19] !== t8 || $[20] !== t9) {
    t10 = {
      transform: t8,
      opacity: swipeOpacity,
      transition: t9
    };
    $[18] = swipeOpacity;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <svg className="tw-size-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" /></svg>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== handleDismiss) {
    t12 = <button onClick={handleDismiss} className="tw-absolute -tw-right-2 -tw-top-2 tw-z-50 tw-hidden tw-size-6 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-indigo-500 tw-text-white tw-opacity-0 tw-transition-all tw-duration-200 group-hover:tw-opacity-50 hover:!tw-opacity-100 lg:tw-flex" aria-label="Dismiss">{t11}</button>;
    $[23] = handleDismiss;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = `tw-flex tw-h-10 tw-min-w-[2.75rem] tw-items-center tw-justify-center tw-gap-2 tw-border-0 tw-bg-indigo-500 tw-px-4 tw-text-white tw-opacity-50 tw-transition-all tw-duration-300 hover:tw-opacity-100 lg:tw-h-8 ${roundedClassName} ${isCombined ? combinedWidthClassName : ""}`;
  let t14;
  if ($[25] !== handleUnreadClick || $[26] !== handlers.onMouseDown || $[27] !== handlers.onMouseLeave || $[28] !== handlers.onMouseMove || $[29] !== handlers.onMouseUp || $[30] !== handlers.onTouchEnd || $[31] !== handlers.onTouchMove || $[32] !== handlers.onTouchStart || $[33] !== t13 || $[34] !== unreadContent) {
    t14 = <button onClick={handleUnreadClick} onTouchStart={handlers.onTouchStart} onTouchMove={handlers.onTouchMove} onTouchEnd={handlers.onTouchEnd} onMouseDown={handlers.onMouseDown} onMouseMove={handlers.onMouseMove} onMouseUp={handlers.onMouseUp} onMouseLeave={handlers.onMouseLeave} className={t13} aria-label="Scroll to first unread message">{unreadContent}</button>;
    $[25] = handleUnreadClick;
    $[26] = handlers.onMouseDown;
    $[27] = handlers.onMouseLeave;
    $[28] = handlers.onMouseMove;
    $[29] = handlers.onMouseUp;
    $[30] = handlers.onTouchEnd;
    $[31] = handlers.onTouchMove;
    $[32] = handlers.onTouchStart;
    $[33] = t13;
    $[34] = unreadContent;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t12 || $[37] !== t14) {
    t15 = <div className="tw-group tw-relative">{t12}{t14}</div>;
    $[36] = t12;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t10 || $[40] !== t15) {
    t16 = <div className="tw-flex-shrink-0" style={t10}>{t15}</div>;
    $[39] = t10;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  return t16;
}